module.exports = __webpack_public_path__ + "static/2024-logo-e3cbcb7b76ad89cb830d26e10f8138fa.png";